module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/en/5-b4603c2e5e81168b1dd3c33b5f66fdb7.jpg";